export default function WhatIsSoftSkills() {
  const differences = [
    { side: 'hard', items: ['Профессиональные знания и техники', 'Можно измерить тестом или экзаменом', 'Осваиваются за дни и недели', 'Быстро устаревают', 'Специфичны для профессии', 'Дают право работать'] },
    { side: 'soft', items: ['Навыки взаимодействия с людьми', 'Проявляются в поведении', 'Формируются месяцами', 'Актуальны всю карьеру', 'Универсальны для любой роли', 'Позволяют добиваться результатов'] },
  ];

  return (
    <section className="py-20 md:py-28 bg-white">
      <div className="max-w-7xl mx-auto px-6">
        <h2 className="text-3xl md:text-5xl font-bold text-gray-900 text-center mb-6">
          Что такое Soft Skills и почему они определяют успех бизнеса
        </h2>
        <p className="text-lg text-gray-600 text-center mb-16 max-w-3xl mx-auto">
          Понимание разницы между Hard Skills и Soft Skills — первый шаг к построению эффективной системы развития сотрудников
        </p>

        <div className="grid lg:grid-cols-2 gap-8 mb-16">
          <div className="bg-gray-50 rounded-2xl p-8">
            <div className="flex items-center gap-3 mb-6">
              <div className="w-12 h-12 bg-teal-600 rounded-xl flex items-center justify-center">
                <i className="ri-tools-fill text-white text-xl"></i>
              </div>
              <h3 className="text-2xl font-bold text-gray-900">Hard Skills</h3>
            </div>
            <ul className="space-y-4">
              {differences[0].items.map((item, i) => (
                <li key={i} className="flex items-start gap-3">
                  <div className="w-6 h-6 bg-teal-100 rounded-full flex items-center justify-center flex-shrink-0 mt-0.5">
                    <span className="text-teal-700 text-xs font-bold">{i + 1}</span>
                  </div>
                  <span className="text-gray-700">{item}</span>
                </li>
              ))}
            </ul>
          </div>

          <div className="bg-teal-50 rounded-2xl p-8">
            <div className="flex items-center gap-3 mb-6">
              <div className="w-12 h-12 bg-teal-600 rounded-xl flex items-center justify-center">
                <i className="ri-heart-line text-white text-xl"></i>
              </div>
              <h3 className="text-2xl font-bold text-gray-900">Soft Skills</h3>
            </div>
            <ul className="space-y-4">
              {differences[1].items.map((item, i) => (
                <li key={i} className="flex items-start gap-3">
                  <div className="w-6 h-6 bg-teal-600 rounded-full flex items-center justify-center flex-shrink-0 mt-0.5">
                    <span className="text-white text-xs font-bold">{i + 1}</span>
                  </div>
                  <span className="text-gray-700">{item}</span>
                </li>
              ))}
            </ul>
          </div>
        </div>

        <div className="relative max-w-4xl mx-auto">
          <div className="bg-gradient-to-r from-gray-800 via-gray-700 to-teal-700 rounded-2xl p-8 md:p-12 text-center">
            <div className="flex flex-col md:flex-row items-center justify-center gap-6 md:gap-10">
              <div className="bg-white/10 backdrop-blur-sm rounded-xl px-6 py-4 text-white">
                <div className="text-sm text-white/70">Hard Skills</div>
                <div className="text-2xl font-bold">Дают право работать</div>
              </div>
              <div className="text-white/60 text-3xl hidden md:block">→</div>
              <div className="text-teal-400 text-3xl md:hidden">↓</div>
              <div className="bg-teal-400/20 backdrop-blur-sm rounded-xl px-6 py-4 text-teal-300 border border-teal-400/30">
                <div className="text-sm text-teal-300/70">Soft Skills</div>
                <div className="text-2xl font-bold">Позволяют добиваться результатов</div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}